import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AiOutlineClose } from 'react-icons/ai';
import { api } from '../../server/api';
export function ModalForms({ showModal, openModal, formId }) {
  console.log('🚀 ~ file: index.jsx:6 ~ ModalForms ~ formId:', formId);
  const [utmCampaign, setUtmCampaign] = useState('');
  useEffect(() => {
    let { pathname } = window.location;
    const url = pathname.split('/');

    setUtmCampaign(url[2]);
  }, []);
  const {
    handleSubmit: handleSubmitForm3,
    register: registerForm3,
    setValue,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const updateInputValue = (e) => {
    setValue('fullname', e.target.value);
  };
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await api.post(
        '/lead',
        {
          utm_medium: data.utm_medium,
          utm_source: data.utm_source,
          utm_campaign: data.utm_campaign,
          fullname: data.fullname,
          email: data.email,
          formId,
        },
        {
          headers: {
            token:
              'dcbbf9d1dd87939fdcf446d5fef2f8ec0ea4382cd4f51bc462211bf7ba83fd47',
          },
        },
      );

      setLoading(false);
      setMessage(true);
    } catch (error) {
      setLoading(false);
      setMessage('Parabéns! Agora fique de olho no seu email para concluir.');
    }
  };
  if (showModal) {
    if (message === true) {
      return (
        <div className="background-modal">
          <div>
            <div className="d-flex justify-content-between mb-2">
              <h3>
                Parabéns, {name} <br /> 🥳 🥳 🥳{' '}
              </h3>

              <AiOutlineClose
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => openModal(!showModal)}
                size={30}
              />
            </div>
            <p>
              Acabamos de te enviar um e-mail te mostrando como enviar as
              curtidas!
            </p>
            <p>Você também pode comprar curtidas aqui:</p>
            <button>
              <a
                style={{ color: 'white' }}
                target="_blank"
                href={`https://www.impulsionegram.com.br/?utm_source=ferramenta&utm_medium=organico&utm_campaign=${utmCampaign}`}
                rel="noreferrer"
              >
                COMPRAR CURTIDAS ➡
              </a>
            </button>
            <p className="text-center my-2 p-0">{message}</p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="background-modal">
          <div>
            <div className="d-flex">
              <h3>Quer ganhar 100 visualizações em seu vídeo do Instagram?</h3>
              <AiOutlineClose
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => openModal(!showModal)}
                size={30}
              />
            </div>
            <p>
              É de graça e apenas precisamos das informações abaixo para
              entregar nossos serviços:
            </p>
            <form onSubmit={handleSubmitForm3(onSubmit)}>
              <input
                type="hidden"
                {...registerForm3('utm_source')}
                value={'ferramenta'}
              />
              <input
                type="hidden"
                {...registerForm3('utm_medium')}
                value={'organico'}
              />
              <input
                type="hidden"
                {...registerForm3('utm_campaign')}
                value={utmCampaign ?? ''}
              />

              <input
                type="text"
                placeholder="Seu nome:"
                {...registerForm3('fullname')}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                type="text"
                placeholder="Seu melhor e-mail"
                {...registerForm3('email')}
              />
              <button>
                {loading ? 'Carregando...' : ' Receber Visualizações Agora'}
              </button>
            </form>
            <p className="text-center my-2 p-0">{message}</p>
          </div>
        </div>
      );
    }
  } else {
    return <></>;
  }
}
